import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ArrowRight, Image as ImageIcon, Package } from "lucide-react";
import { GetOperationsBrand } from "../../common/CommonApi";

const OperationsManage = () => {
  const navigate = useNavigate();
  const [brandsList, setBrandsList] = useState([]);

  useEffect(() => {
    brandsListOne();
  }, []);

  async function brandsListOne() {
    const brandsList = await GetOperationsBrand();
    setBrandsList(brandsList?.data?.data || []);
  }

  function brandsOne(id) {
    navigate(`/operation/brands?id=${id}`);
  }

  return (
    <Wrapper>
      <HeaderBlock>
        <div>
          <Title>Our Partners Products</Title>
          <Subtitle>Review partner catalogs and product verification queues.</Subtitle>
        </div>
      </HeaderBlock>

      <BrandGrid>
        {brandsList.map((brand) => (
          <BrandCard key={brand._id} type="button" onClick={() => brandsOne(brand?._id)}>
            <BrandMedia>
              {brand.brandImage ? (
                <BrandImage src={brand.brandImage} alt={brand.brandName || "Partner brand"} />
              ) : (
                <ImageFallback>
                  <ImageIcon size={24} />
                </ImageFallback>
              )}
            </BrandMedia>

            <BrandInfo>
              <BrandName>{brand.brandName}</BrandName>
              <ProductCount>
                <Package size={15} />
                {brand.totalProducts || 0} products
              </ProductCount>
            </BrandInfo>

            <ViewAction>
              View products
              <ArrowRight size={15} />
            </ViewAction>
          </BrandCard>
        ))}
      </BrandGrid>
    </Wrapper>
  );
};

export default OperationsManage;

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 28px;
  background: #f8fafc;

  @media (max-width: 768px) {
    padding: 0;
    min-height: auto;
  }
`;

const HeaderBlock = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 22px;
`;

const Title = styled.h2`
  color: #0f172a;
  font-size: 28px;
  font-weight: 800;
  margin: 0;
`;

const Subtitle = styled.p`
  color: #64748b;
  font-size: 14px;
  margin: 6px 0 0;
`;

const BrandGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

const BrandCard = styled.button`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 20px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    border-color: #32d5c9;
    box-shadow: 0 12px 30px rgba(50, 213, 201, 0.15);
  }
`;

const BrandMedia = styled.div`
  width: 100px;
  height: 100px;
  margin: auto;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #fff;
`;

const BrandImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 8px;
`;

const ImageFallback = styled.div`
  color: #94a3b8;
`;

const BrandInfo = styled.div`
  margin-top: 16px;
`;

const BrandName = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 10px;
`;
const ProductCount = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ecfdf5;
  color: #059669;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
`;

const ViewAction = styled.div`
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #32d5c9;
  font-weight: 700;
  font-size: 14px;
`;
